<h4 class="m-0">My Profile</h4>

<div class="bg-white mt-3 rounded">
	<p-tabView
		[activeIndex]="activeIndex()"
		(activeIndexChange)="activeIndex.set($event)"
		class="p-3"
	>
		<p-tabPanel header="My Account" headerStyleClass="p-1">
			<ng-template pTemplate="content">
				<app-my-profile-accounts></app-my-profile-accounts>
			</ng-template>
		</p-tabPanel>

		<!--<p-tabPanel header="Security" headerStyleClass="p-1">
			<ng-template pTemplate="content">
				<app-my-profile-security></app-my-profile-security>
			</ng-template>
		</p-tabPanel>-->

		<!--<p-tabPanel header="Notifications" headerStyleClass="p-1">
			<ng-template pTemplate="content">
				<app-my-profile-notifications></app-my-profile-notifications>
			</ng-template>
		</p-tabPanel>-->
	</p-tabView>
</div>
